// extracted by mini-css-extract-plugin
export var required = "_gr-0";